import { mutations } from "@/graphql";
import { useMutation } from "@apollo/client/react";
import { useState } from "react";
import { enqueueSnackbar } from "notistack";
import type { UpdatePassword } from "@/types/graphql";

type ChangePasswordResponse = {
  updatePassword?: UpdatePassword | null;
  comUpdatePassword?: UpdatePassword | null;
};

export const useChangePassword = (
  onCompleted: (data?: any) => void = () => {},
  onError: (error?: any) => void = () => {},
) => {
  const [success, setSuccess] = useState(false);

  const [changePassword, { loading }] = useMutation<ChangePasswordResponse>(
    mutations.changePasswordMutatiion,
    {
      onCompleted: (response) => {
        const res = response?.updatePassword || response?.comUpdatePassword;
        if (res && res.success === "true") {
          setSuccess(true);
          onCompleted();
        } else {
          if (res?.message?.length) {
            res.message.forEach((msg: string | null) => {
              if (msg) {
                enqueueSnackbar(msg, {
                  variant: "error",
                });
              }
            });
          }

          setSuccess(false);
        }
      },
      onError: (error) => {
        setSuccess(false);
        onError(error);
      },
    },
  );
  return {
    changePassword,
    loading,
    success,
  };
};
